import Firebase from 'firebase'
import ReactGA from 'react-ga'
import { toast } from 'react-toastify'

import { prepareForCreate } from '../data/db_util'

const createGame = (nameOfTheGame) => {
  return addNewGame(nameOfTheGame)
    .then(addPlayerToGame)
    .then( ({gameRef}) => {
      toast('Created a new game!')
      ReactGA.event({
        category: 'Game',
        action: 'Created a new game',
      })
      return gameRef.id
    }).catch( error => {
      toast.error("Sorry, we couldn't create a game--try again in a minute?")
      console.error("Error creating game: ", error)
    })
}

const addNewGame = name => {
  const newGame = prepareForCreate({
    name,
    started: false,
    // TODO - admins: [Firebase.auth().currentUser.uid],
  })
  return Firebase.firestore().collection("games").add(newGame)
}

const addPlayerToGame = gameRef => {
  const newPlayer = {
    game: gameRef.id,
    user: Firebase.auth().currentUser.uid,
    name: Firebase.auth().currentUser.displayName,
    joinedAt: new Date(),
    alive: true,
    admin: true,
  }
  return Firebase.firestore().collection("players").add(newPlayer).then( () => ({gameRef}) )
}

export default createGame



// WEBPACK FOOTER //
// ./src/actions/createGame.js